module.exports={render:function (){var _vm=this;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "container",
    attrs: {
      "id": "servicios"
    }
  }, [_vm._h('div', {
    staticClass: "header"
  }, [_vm._h('h2', ["CONOZCA NUESTROS SERVICIOS"])]), " ", _vm._h('div', {
    staticClass: "row"
  }, [_vm._h('div', {
    staticClass: "col-md-4"
  }, [_vm._h('div', {
    staticClass: "card"
  }, [_vm._h('img', {
    staticClass: "card-img-top mx-auto d-block",
    attrs: {
      "src": "/static/home/icono1.png",
      "alt": "Card image cap"
    }
  }), " ", _vm._h('div', {
    staticClass: "card-block text-justify"
  }, [_vm._h('p', {
    staticClass: "card-text",
    staticStyle: {
      "font-size": "15px"
    }
  }, ["Somos parte de un mundo globalizado,\n                        un mundo en constante movimiento. No alcanza con adaptarse a los cambios... \n                        hay que anticiparse a ellos. Para lograrlo, resulta imprescindible participar activamente\n                        y mantenerse informado de las últimas tendencias en el mercado local, nacional, regional e internacional."]), " ", _vm._h('p', {
    staticClass: "card-text text-justify",
    staticStyle: {
      "font-size": "13px"
    }
  }, ["\n                        Con ", _vm._h('b', ["WPO"]), " dispones de una plataforma para comprar y vender autopartes con cobertura/alcance\n                        sobre todo el territorio nacional. Además, te mantendremos al tanto de las últimas noticias,\n                        informes y acontecimientos relacionados a este segmento.\n                    "])])])]), " ", _vm._h('div', {
    staticClass: "col-md-4"
  }, [_vm._h('div', {
    staticClass: "card"
  }, [_vm._h('img', {
    staticClass: "card-img-top mx-auto d-block",
    attrs: {
      "src": "/static/home/icono2.png",
      "alt": "Card image cap"
    }
  }), " ", _vm._h('div', {
    staticClass: "card-block text-justify"
  }, [_vm._h('p', {
    staticClass: "card-text",
    staticStyle: {
      "font-size": "15px"
    }
  }, ["\n                        El mercado de autopartes está compuesto por repuestos, recambios y accesorios varios\n                        destinados a todo tipo de vehículos (automóviles, motocicletas, trasporte pesado y de pasajeros).\n                        Tanto nuevos o usados, como originales u alternativos.   \n                    "]), " ", _vm._h('p', {
    staticClass: "card-text text-justify",
    staticStyle: {
      "font-size": "13px"
    }
  }, ["\n                        Con ", _vm._h('b', ["WPO"]), " tenés acceso a todo este abanico de posibilidades, agrupadas y ordenadas\n                        según tus preferencias, para que siempre encuentres aquello que estás buscando... \n                        para que siempre llegues primero al cliente.\n                    "])])])]), " ", _vm._h('div', {
    staticClass: "col-md-4"
  }, [_vm._h('div', {
    staticClass: "card"
  }, [_vm._h('img', {
    staticClass: "card-img-top mx-auto d-block",
    attrs: {
      "src": "/static/home/icono3.png",
      "alt": "Card image cap"
    }
  }), " ", _vm._h('div', {
    staticClass: "card-block"
  }, [_vm._h('p', {
    staticClass: "card-text text-justify",
    staticStyle: {
      "font-size": "15px"
    }
  }, ["\n                        Con el surgimiento de internet, los requerimientos han cambiado. \n                        El mercado cuenta con mayor acceso a la información y por lo tanto, \n                        con más herramientas para comparar ofertas y escoger por aquello que\n                        mejor se adapte a sus necesidades.\n                        Frente a este escenario, el comercio electrónico se ha convertido\n                        en una pieza clave para el crecimiento y expansión de cualquier negocio.\n                        Contar con este canal de ventas, significa aumentar tus probabilidades de éxito.\n                    "]), " ", _vm._h('p', {
    staticClass: "card-text text-justify",
    staticStyle: {
      "font-size": "13px"
    }
  }, ["\n                        En ", _vm._h('b', ["WPO"]), " dispones de un sistema e-commerce con estándares universales.\n                        Mediante una interface ágil, intuitiva y personalizable, te facilitaremos\n                        la interacción con tus clientes y/o proveedores ahorrándote tiempo\n                        para que optimices cada transacción. \n                    "])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10a08d7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home-Servicios.vue
// module id = 65
// module chunks = 1